import { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './Button';

export interface ErrorBoxProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
  icon?: ReactNode;
}

/**
 * Error box component for displaying error messages with optional retry action
 */
export function ErrorBox({
  title = 'Error',
  message,
  onRetry,
  retryLabel = 'Try Again',
  className = '',
  icon,
}: ErrorBoxProps) {
  return (
    <div data-tsx-id="error-box" className={`rounded-md bg-red-50 border border-red-200 p-4 ${className}`}>
      <div className="flex">
        <div className="flex-shrink-0">
          {icon || <AlertTriangle className="h-5 w-5 text-red-400" />}
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-red-800">
            {title}
          </h3>
          <div className="mt-2 text-sm text-red-700">
            <p>{message}</p>
          </div>
          {onRetry && (
            <div className="mt-4">
              <Button
                variant="danger"
                size="sm"
                onClick={onRetry}
              >
                {retryLabel}
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
